<template>
    <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content" :style="{ width: width}">
        <h5 class="modal-title">{{ title }}</h5>
  
        <div class="modal-body">
          <slot></slot>
        </div>
  
        <div v-if="!isLoading" class="d-flex justify-content-center gap-3">
          <button type="button" v-if="!hideSend" class="btn btn-primary" @click="sendOptions">Enviar</button>
          <button type="button" class="btn btn-secondary" @click="closeModal">Fechar</button>
        </div>
        <div v-if="isLoading">Carregando...</div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      isModalOpen: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      width: {
        type: String,
        required: false
      },
      isLoading: {
        type: Boolean,
        required: false
      },
      hideSend: false
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
      sendOptions() {
        this.$emit('send'); 
      },
    },
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    max-height: 90%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    overflow-y: auto;
  }
  
  .modal-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
    text-align: center;
  }
  
  .modal-body {
    margin-bottom: 15px;
  }
  </style>
  